export default {
  APP: {
    NAME: 'Transporteurs',
    COMPANY: 'Freightforge'
  },
  ACTIONS: {
    RETRY: 'Réessayer',
    EDIT: 'Editer',
    VISUALIZE: 'Visualiser'
  },
  CARRIERS_DETAIL: {
    TITLE: 'Détails'
  },
  CARRIERS_EDIT: {
    TITLE: 'Edition'
  },
  RATE_REQUESTS_LIST: {
    TITLE: 'Taux de réponses'
  },
  CONTRACTS_LIST: {
    TITLE: 'Contrats'
  }
}
